export default __webpack_public_path__ + "static/media/loading-opening.1394a324.gif";